import SearchIcon from "@mui/icons-material/Search";

import useStyles from './useStyles'
import {SearchInputBase} from "./SearchInputBase";
import {useCallback, useContext, useRef, useState} from "react";
import {FilterContext} from "../Filter/Context";

export const SearchComponent = () => {

    const classes = useStyles()

    const {onFilterChange} = useContext(FilterContext);
    const [ formActive, setFormActive ] = useState(false)
    const searchRef = useRef(null)

    const handleMouseOut = useCallback((currentRef) => {
        setFormActive(document.activeElement === currentRef || currentRef.value)
    },[]);

    const onFilterChangeHandler = useCallback((currentRef) => {
        handleMouseOut(currentRef)
        onFilterChange(currentRef.value)
    },[])

    return (
        <div className={`${classes.searchComponent} ${formActive ? classes.searchComponentActive : ''}`}>
            <div className={classes.searchIconWrapper}>
                <SearchIcon />
            </div>
            <SearchInputBase
                placeholder="Поиск…"
                inputProps={{ 'aria-label': 'search' }}
                className={classes.searchInput}
                inputRef={searchRef}
                onBlur={() => handleMouseOut(searchRef.current)}
                onFocus={() => handleMouseOut(searchRef.current)}
                onChange={() => onFilterChangeHandler(searchRef.current)}
            />
        </div>
    )
}

